import { FunctionComponent, useEffect } from "react";
import useVerifyCampaign from "@form/hooks/useVerifyCampaign";
import { useRouter } from "next/router";

const SourceTrack: FunctionComponent = () => {
  const router = useRouter();
  const { changeVerifyState, changeForm, form } = useVerifyCampaign(`source`);

  useEffect(() => {
    changeVerifyState(true);
    changeForm(router.query.source);
  }, [router]);

  return null;
};

export default SourceTrack;
